export const FETCH_CALENDARS_ENDPOINT = '/api/v2.0/me/calendars';
export const FETCH_CALENDARGROUPS_ENDPOINT = '/api/v2.0/me/calendarGroups';
export const SCENARIONAME_HEADERNAME = 'Prefer';
export const SCENARIONAME_HEADERVALUE = 'exchange.behavior="ReorderCalendars"';
